const dictionary = {
  socket_timeout: 'مشکل در ارتباط با سرور',
}

export default dictionary
